<template>

  <div v-if="editMode || filled">
    <div class="card-header">
      <i
        v-if="!editable && editMode"
        class="fas fa-pencil-alt"
        :title="$t('Edit')"
        @click.stop="editSection(true)"
        style="cursor: pointer; float: right;">
        </i>
      <strong>{{ $t('Educations') }}</strong>
    </div>
    <div class="card-body" v-if="editable">
      <form v-on:submit.prevent="save(candidateEdit)" class="list-group">
        
        <div 
          v-for="(education, index) in candidateEdit.educations"
          :key="index"
          class="list-group-item p-4">

          <div class="form-group row">
            <label class="col-sm-3 col-form-label">{{ $t('Degree') }} *</label>
            <div class="col-sm-9">
              <select-education-degree v-model="education.education_degree"></select-education-degree>
              <ValidateMessage :error="validateErrors['educations.' + index + '.education_degree']" />
            </div>
          </div>
          <div class="form-group row">
            <label class="col-sm-3 col-form-label">{{ $t('Course') }} *</label>
            <div class="col-sm-9">
              <input class="form-control" type="text" v-model="education.course">
              <ValidateMessage :error="validateErrors['educations.' + index + '.course']" />
            </div>
          </div>
          <div class="form-group row">
            <label class="col-sm-3 col-form-label">{{ $t('Institution') }} *</label>
            <div class="col-sm-9">
              <input class="form-control" type="text" v-model="education.institution">
              <ValidateMessage :error="validateErrors['educations.' + index + '.institution']" />
            </div>
          </div>
          <div class="form-group row">
            <label class="col-sm-3 col-form-label">{{ $t('Period') }}</label>
            <div class="col-sm-9">
              <div class="d-flex">
                <div class="mr-3">
                  <input-month
                    v-model="education.start_date"
                    :placeholder="$t('Start date')"
                    width="110"
                    initialSelect="year">
                    </input-month>
                  <ValidateMessage :error="validateErrors['educations.' + index + '.start_date']" />
                </div>
                <div class="mr-3 pt-1 pb-1">
                  até
                </div>
                <div class="mr-3">
                  <input-month
                    v-model="education.end_date"
                    :placeholder="$t('End date')"
                    width="110"
                    initialSelect="year">
                    </input-month>
                  <ValidateMessage :error="validateErrors['educations.' + index + '.end_date']" />
                </div>
                <div class="form-control-plaintext">
                  <div class="form-check">
                    <label class="form-check-label">
                      <input class="form-check-input" type="checkbox" v-model="education.incomplete">
                      {{ $t('Incomplete') }}
                    </label>
                  </div>
                  <ValidateMessage :error="validateErrors['educations.' + index + '.current_job']" />
                </div>
              </div>
            </div>
          </div>
          <a href="javascript:void(0)" @click="removeItem(index)">{{ $t('Remove') }}</a>
        </div>

        <div class="mt-3 mb-3">
          <a href="javascript:void(0)" @click="addItem()">{{ $t('Add education') }}</a>
        </div>

        <div :class="{'box-loading': loading}">
          <button
            type="submit"
            class="btn btn-primary">
            {{ $t('Save') }}
            </button>
          <button
            type="button"
            class="btn btn-light"
            @click.stop="editSection(false)">
            {{ $t('Cancel') }}
            </button>
        </div>

      </form>
    </div>
    <div
      v-if="!editable && filled"
      class="card-body">
      <ul class="education-list">
        <li
          v-for="(education, index) in candidate.educations"
          :key="index"
          class="row">
          <div class="col-sm-3"><span class="date">{{ getFullDate(education) }}</span></div>
          <div class="col-sm-9">
            <div class="course">
              {{ getEducationDegree(education.education_degree) }} <strong>{{ education.course }}</strong> <span v-if="education.incomplete"> - {{ $t('Incomplete') }}</span>
            </div>
            <div class="institution">{{ education.institution }}</div>
          </div>
        </li>
      </ul>
    </div>
  </div>

</template>

<script>
import InputMonth from '@/components/Fields/InputMonth'
import moment from 'moment'
import SelectEducationDegree from '@/components/Fields/SelectEducationDegree'

export default {
  name: 'CandidateProfileSkills',
  components: {
    InputMonth,
    SelectEducationDegree
  },
  props: [
    'editMode'
  ],
  data () {
    return {
      loading: false,
      sectionEdit: false,
      candidateEdit: {},
      validateErrors: false
    }
  },
  created () {
  },
  computed: {
    editable () {
      return this.sectionEdit && this.editMode
    },
    candidate () {
      return this.$store.getters.getCandidate
    },
    resources () {
      return this.$store.getters.getResources
    },
    filled () {
      return this.candidate.educations && this.candidate.educations.length
    }
  },
  methods: {
    editSection (status) {
      this.sectionEdit = status

      this.candidateEdit = {
        _id: this.candidate._id,
        educations: Array.isArray(this.candidate.educations) ? this.candidate.educations : []
      }
    },
    save (data) {
      this.loading = true

      this.$store.dispatch('updateCandidate', data)
      .then((response) => {
        this.loading = false
        this.sectionEdit = false
      })
      .catch((err) => {
        this.loading = false
        if (err.response.data.name === 'ValidationError') {
          this.validateErrors = err.response.data.errors
        }
      })
    },
    /*
    getFullDate
    */
    getFullDate (education) {
      let interval = [
        (education.start_date ? moment.utc(education.start_date).format('MM/YYYY') : null),
        (education.end_date ? moment.utc(education.end_date).format('MM/YYYY') : null)
      ]
      .filter((v) => { return v })
      .join(' - ')

      return interval
    },
    /*
    addItem
    */
    addItem () {
      this.candidateEdit.educations.push({})
    },
    /*
    removeItem
    */
    removeItem (index) {
      this.candidateEdit.educations.splice(index, 1)
    },
    /*
    getEducationDegree
    */
    getEducationDegree (key) {
      const level = this.resources.education_degree.filter((value) => {
        return value.key === key
      })[0] || {}

      return level.name ? `${level.name}, ` : ''
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .education-list{
    list-style: none;
    padding: 0;
    margin: 0; 
  }
    .education-list > li{
      margin-bottom: 1.3em;
    }
    .education-list .date{
      font-size: 0.9em;
      opacity: 0.75; 
    }
</style>



// WEBPACK FOOTER //
// src/components/Candidate/Profile/CandidateProfileEducations.vue